import React from 'react';

import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { DynamicComponent } from 'ui';
import twMerge from 'utils/twMerge';

const classNames = {
  p: 'md:tp-text tp-mobile-text',
  h1: 'md:tp-header-1 tp-mobile-header-1',
  h2: 'md:tp-header-2 tp-mobile-header-2',
  h3: 'md:tp-header-3 tp-mobile-header-3',
  h4: 'md:tp-header-4 tp-mobile-header-4',
  em: 'italic',
  b: 'font-bold',
  a: 'text-mint',
};
const Text = React.forwardRef(
  ({
    children, as = 'p', variant, tag, className, center, ...attrs
  }, ref) => (
    <DynamicComponent
      ref={ref}
      tag={tag || as}
      className={twMerge(cn(className, classNames[as], classNames[variant], {
        'text-center w-full inline-block': center,
      }))}
      {...attrs}
    >
      {children}
    </DynamicComponent>
  ),
);

Text.displayName = 'Text';
Text.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Text;
